
import { appSize } from "@/common/AppConst";
import { Component, Vue, Watch } from "vue-property-decorator";
import leftnav from "./leftnav.vue";

@Component({
  components: {
    leftnav,
  },
})
export default class Layout extends Vue {
  readonly leftNavWidth: string = appSize.leftNavWidthPercent + "%";
  readonly mainWidth: string = 100 - appSize.leftNavWidthPercent + "%";

  /** 活动图片倒计时 */
  promotionsCd: number = 5;
  /** 活动图片显示计时器 */
  promotionsCounter: any = null;

  @Watch("promotionsCd")
  onPromotionsCdChange(cd: number) {
    if (cd <= 0 && this.promotionsCounter)
      clearInterval(this.promotionsCounter);
  }

  mounted() {
    // 倒数活动图片倒计时
    if (!this.promotionsCounter) clearInterval(this.promotionsCounter);
    this.promotionsCounter = setInterval(() => {
      this.promotionsCd--;
    }, 1000);
  }

  /**
   * 关闭顶部海报
   */
  closePromotions() {
    this.promotionsCd = 0;
  }
}
